module.exports = __webpack_public_path__ + "img/step1.4a2e2670.png";